import PingFangSemiBoldText from './PingFangSemiBoldText';

export default PingFangSemiBoldText;
